module.exports = __webpack_public_path__ + "img/ico-connect.2f883faa.svg";